import type { ComponentType } from 'react';
import type { HomeWidgetConfig } from '@config/env/types';
import { SupportWidget } from './SupportWidget';
import { EventsWidget } from './EventsWidget';
import { PanicWidget } from './PanicWidget';
import { UtilitiesWidget } from './UtilitiesWidget';
import { AccountWidget } from './AccountWidget';
import { NewsWidget } from './NewsWidget';

export interface WidgetProps {
  config: HomeWidgetConfig;
}

interface WidgetDefinition {
  /** Default header title when the env config doesn't override it. */
  defaultTitle: string;
  component: ComponentType<WidgetProps>;
}

/**
 * Registry of home dashboard widgets, keyed by `HomeWidgetConfig.type`. Add new
 * widgets here (e.g. a future `utilities` meter-usage widget) and reference them
 * from the env `home.widgets` JSON.
 */
export const WIDGET_REGISTRY: Record<string, WidgetDefinition> = {
  support: { defaultTitle: 'Helpdesk', component: SupportWidget },
  events: { defaultTitle: 'Upcoming events', component: EventsWidget },
  panic: { defaultTitle: 'Emergency', component: PanicWidget },
  utilities: { defaultTitle: 'Utilities', component: UtilitiesWidget },
  account: { defaultTitle: 'Account', component: AccountWidget },
  news: { defaultTitle: 'News', component: NewsWidget },
};

export function widgetTitle(config: HomeWidgetConfig): string {
  return config.title ?? WIDGET_REGISTRY[config.type]?.defaultTitle ?? config.type;
}
